import React from 'react';

export const pageMeta = {
  "name": "JS Strict Mode",
  "link": "/javascript/programming/strict-mode"
};

export default function JavascriptProgrammingStrictMode() {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">JS Strict Mode</h2>
      <p>Route: /javascript/programming/strict-mode</p>
      <h3 className="mt-4 font-medium">sub_content</h3>
      <pre>{JSON.stringify(pageMeta, null, 2)}</pre>
    </div>
  );
}
